<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'Feedback' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <form class="content-width" *ngIf="formActive" [formGroup]="form">
        <ion-list>
            <ion-item>
                <ion-select label="{{'Can we contact you?' | translate}}" label-placement="floating" #contactMethod formControlName="contactMethod" interface="popover">
                    <ion-select-option value="none">{{'No' | translate}}</ion-select-option>
                    <!-- <ion-select-option value="phone" *ngIf="authService.authUserSignal()?.phone">Yes, text message</ion-select-option> -->
                    <ion-select-option value="email">{{'Yes, email' | translate}}</ion-select-option>
                </ion-select>
            </ion-item>
            <ion-item *ngIf="contactMethod.value === 'email'">
                <ion-input label="{{'Email' | translate}}" label-placement="floating"  type="text" formControlName="email"></ion-input>
            </ion-item>
            <ion-item>
                <ion-textarea label="{{'Message' | translate}}" label-placement="floating" formControlName="description" placeholder="{{'Enter your feedback' | translate}}" rows="8"></ion-textarea>
            </ion-item>
        </ion-list>
        <ion-button [disabled]="isSending" (click)="submit()" expand="block" class="ion-margin">
            <ion-spinner *ngIf="isSending" name="crescent"></ion-spinner>
            <span *ngIf="!isSending">{{'Submit' | translate}}</span>
        </ion-button>

    </form>
</ion-content>